import { Pipe, PipeTransform } from '@angular/core';
import { Address } from '@src/app/core/models/address.model';
import { DropdownItem } from '@src/app/core/models/drop-down-list.model';
import { UtilsService } from '@src/app/core/services/utils.service';
import { PageCacheService } from '@src/app/features/search/services/page-cache.service';
import { combineLatest, Observable, of, Subject } from 'rxjs';

@Pipe({
  name: 'viewAddress',
})
export class ViewAddressPipe implements PipeTransform {
  constructor(
    private pageCacheService: PageCacheService,
    private utilsService: UtilsService
  ) {}

  transform(address: Address, args: any[]): Observable<string> {
    const { level1, level2, level3, level4 } = address;
    const level1Options: DropdownItem[] = args[0] || [];
    const observables$: Observable<DropdownItem[]>[] = [];
    const result$ = new Subject<string>();

    if (level1 && level2) {
      observables$.push(
        this.pageCacheService.getDropdownList('AddressLevel2', level1, false)
      );
    }

    if (level2 && level3) {
      observables$.push(
        this.pageCacheService.getDropdownList('AddressLevel3', level2, false)
      );
    }

    if (level3 && level4) {
      observables$.push(
        this.pageCacheService.getDropdownList('AddressLevel3', level3, false)
      );
    }

    if (observables$.length) {
      combineLatest(observables$).subscribe(
        ([level2Options, level3Options, level4Options]) => {
          const formatAddress = this.utilsService.convertAddressToString(
            this.utilsService.mappingAddressByOptions(address, {
              level1: level1Options,
              level2: level2Options,
              level3: level3Options,
              level4: level4Options,
            })
          );

          result$.next(formatAddress);
        }
      );
    } else {
      const formatAddress = this.utilsService.convertAddressToString(
        this.utilsService.mappingAddressByOptions(address, {
          level1: level1Options,
          level2: [],
          level3: [],
          level4: [],
        })
      );

      return of(formatAddress);
    }

    return result$;
  }
}
